import { TradeMethodFilesValidationPage } from 'features/trade-methods';

export const AdminTradeMethodFilesValidationPage: React.FC = () => (
  <TradeMethodFilesValidationPage />
);
